module.exports = {
    url:"https://lovewav.herokuapp.com"
}